import { usePatient } from "../state/patientContext";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";

export const useTranslate = () => {
  const { gender } = usePatient();
  return useTranslateByGender(gender);
};
